import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";

@Component({
  selector: 'hawk-bare-layout-component',
  imports: [
    RouterOutlet
  ],
  templateUrl: './bare-layout.component.html',
  styleUrl: './bare-layout.component.scss'
})
export class BareLayoutComponent {

}
